<template>
    <div id="viewLogo">
        <vue-typer
            id="title"
            class="black title"
            :text="'sowon choi'"
            :repeat="0"
            :type-delay="120"
            caret-animation="solid"
        ></vue-typer>
    </div>
</template>
<script>
import { VueTyper } from "vue-typer";
export default {
    name: "ViewLogo",
    components: {
        VueTyper,
    },
    mounted() {
        var $title = document.getElementById("viewLogo");
        var val = window.innerHeight + "px";
        $title.style.height = val;
        $title.style.lineHeight = val;
    },
};
</script>
<style>
#viewLogo {
    background-color: #12104e;
    text-align: center;
}
#viewLogo span {
    font-size: 1.9em;
    font-family: black;

    font-family: "Black Han Sans", sans-serif;
    color: #edb352;
}
#viewLogo span.caret {
    background-color: #12104e;
}
</style>
